import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@xo-union/tk-component-buttons';
import styles from './modal-error.scss';

class ModalError extends React.Component {
  static propTypes = {
    messageType: PropTypes.oneOf(['eventMeals', 'default']).isRequired,
    closeModal: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = { reloading: false };
  }

  handleClick = () => {
    this.setState({ reloading: true });
    ModalError.windowReload();
  };

  static windowReload() {
    window.location.reload();
  }

  render() {
    if (this.props.messageType === 'eventMeals') {
      return (
        <div className={styles.modalError}>
          <div className={styles.modalErrorBox}>
            <h3 className={styles.modalErrorTitle}>Oops!</h3>
            <p>Meals can&apos;t be changed since guests have already started to RSVP.</p>
            <Button size="md" color="primary" onClick={this.props.closeModal}>
              Got It
            </Button>
          </div>
        </div>
      );
    }
    return (
      <div className={styles.modalError}>
        <div className={styles.modalErrorBox}>
          <p>
            Oops, it looks like we encountered a problem with your request. Please reload the page to continue. If you
            see this message again, send us an email at help@theknot.com with the problem and we will try to help.
          </p>
          <Button size="md" color="primary" onClick={this.handleClick} disabled={this.state.reloading}>
            Reload
          </Button>
        </div>
      </div>
    );
  }
}

export default ModalError;
